import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { centered } from "@ui/style/style";
import { Trans, useTranslation } from "react-i18next";
import DisplayFormattedMessage from "@ui/components/DisplayFormattedMessage";
import "moment/locale/en-gb";
import "moment/locale/nl";
export const NoEventMsg = () => {
    const theme = useTheme();
    const isBelow1024 = useMediaQuery(theme.breakpoints.down(1025)); // to trigger responsiveness on 1024px
    const isBelow390 = useMediaQuery(theme.breakpoints.down(391)); // to trigger responsiveness on 391px
    const { t } = useTranslation();
    return (_jsx(Box, { sx: {
            px: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
        }, children: _jsxs(Box, { sx: {
                ...centered,
                flexDirection: "column",
            }, children: [_jsx(Box, { component: "img", src: "/assets/images/relations-day-logo.svg", sx: {
                        width: "auto",
                        height: `min(${isBelow390 ? 188 : isBelow1024 ? 144 : 200}px, 26.5dvh)`,
                    }, alt: "feature image" }), _jsx(Typography, { fontSize: { xs: 22, sm: 24, lg: 40 }, mt: 2, textAlign: "center", fontFamily: "Formula1", fontWeight: 500, lineHeight: "100%", color: "#FFFFFF", textTransform: "uppercase", children: _jsx(DisplayFormattedMessage, { text: t("event.noEvent") }) }), _jsx(Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid #00244D33",
                        borderRadius: 2,
                        width: "100%",
                        maxWidth: 589,
                        padding: 3,
                        mt: 3,
                        gap: 3,
                        backgroundColor: "#FFFFFF",
                        p: "40px 48px",
                        boxShadow: "0px 40px 56px 0px #00000014,  0px 16px 40px 0px #0000000F, 0px 4px 8px 0px #0000000A",
                    }, children: _jsx(Typography, { variant: "subtitle1", fontWeight: 400, color: "#00244D", children: _jsx(Trans, { i18nKey: t("event.noEventMsg"), components: {
                                bold: _jsx("span", { style: { fontWeight: 500 } }),
                            } }) }) })] }) }));
};
